import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { Row } from '../grid/experimental.grid';

export interface FocusSelectorSelectActiveForTeamRow {
    rowId: Row['id'];
}

export const focusSelectorSelectActiveForTeamRow = createAction<
    ActionType,
    FocusSelectorSelectActiveForTeamRow
>(ActionType.COACHING_FOCUS_SELECTOR__SELECT_ACTIVE_FOR_TEAM_ROW);
